import React, { useState } from "react";
// import Content from "../components/Programs/Content";
import Aside from "../modules/SideNav/Aside";
import AllStudents from "../pages/AllStudents/AllStudents";
// import CareerDashboard from "../pages/CareerDashboard/CareerDashboard";

function AllStudentsLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <>
      {/* <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      /> */}
      <AllStudents handleToggleSidebar={handleToggleSidebar} />
    </>
  );
}

export default AllStudentsLayout;
